export const POD_ID = 'https://go.gupshup.io';
export const MUNCHKIN_ID = '887-CRJ-697';
export const MKTOFORM_ID_PREFIX = 'mktoForm_';
export const MKTOFORM_ID_ATTRNAME = 'data-form-id';
export const DISALLOWED_DOMAINS = [
  'gmail.com',
  'yahoo.com',
  'rediff.com',
  'gmail',
  'gmail.co',
  'gmail.in',
  'gmil.com',
  'gmsil.com',
  'gamil.com',
  'ymail.com',
  'pvtgmail.com',
  'email.com',
  'pvtgamil.com',
  'marketinggmail.com',
  'jmail.com',
  'icloud.com',
  'hmail.com',
  'gmil.cam',
  'gmeil.com',
  'gmilcom',
  'outlook.com',
  'gmeal.com',
  'hotmail.com',
  'gail.com',
  'email.com',
  'gamil',
  'gamil.co',
  'gamil.com',
  'gemil.com',
  'gim',
  'gimel.com',
  'giol',
  'gm.com',
  'gma',
  'gmai',
  'gmai.com',
  'gmail',
  'gmail.c',
  'GMAIL.COM',
  'gmailcom',
  'gmailod.com',
  'gmal.com',
  'gmali.com',
  'gmall.com',
  'gmial.com',
  'gmil',
  'gmil.com',
  'google.com',
  'protonmail.com',
  'rediff.com',
  'rediffmail.com',
  'support.whatsapp.com',
  'workmail.com',
  'www.com',
  'yahoo.co.in',
  'yahoo.com',
  'yahoo.in',
  'yahoo.n',
  'yahoo.c',
  'ymail',
  'hotmail.com',
  'mailto.plus',
];
